export default __webpack_public_path__ + "021c2ea2fa5c2b69888d3a531c160789.png";